import { Field, Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { routingConstants } from "@/Constants/routingConstants";
import { toggleAccountVerificationModal } from "@/reducers/auth";
import { _verifyAccount } from "@/services/auth";
import { handleAPICatch, showSuccessToast } from "@/utilities/utils";

import AuthButton from "../auth/AuthButton";
import LoginFormTopContent from "../auth/LoginFormTopContent";
import FieldErrorMessage from "../common/FieldErrorMessage";
import ModalPopUp from "../common/ModalPopUp";

/**
 * AccountVerificationModal component function.
 *
 * @return {JSX.Element} The AccountVerificationModal component
 */
const AccountVerificationModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showAccountVerificationModal, new_user, accountVerificationFrom } =
    useSelector((state) => state.auth);
  return (
    <ModalPopUp
      show={showAccountVerificationModal}
      panelClass="max-w-[441px] p-[45px]"
    >
      <Formik
        initialValues={{
          verify_code: "",
          include_in_mailshot: new_user.include_in_mailshot,
          user_type: new_user.type,
          user_id: new_user.id,
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
        onSubmit={(values, { setSubmitting }) => {
          var response = _verifyAccount(values);
          response
            .then((res) => {
              // console.log("res =>", res);
              if (accountVerificationFrom == "login") {
                showSuccessToast("Account Verified Successfully, Please Login");
                dispatch(toggleAccountVerificationModal(false));
              } else {
                dispatch(toggleAccountVerificationModal(false));
                // router.visit(routingConstants.login);
                navigate(routingConstants.login);
              }
            })
            .catch((error) => {
              handleAPICatch(error);
            })
            .finally(() => {
              setSubmitting(false);
            });
        }}
      >
        {({ submitForm, isSubmitting, errors, touched, isValid, values }) => (
          <Form className="flex flex-col gap-6">
            <LoginFormTopContent
              title={"Account Verification"}
              titleClass="text-center"
              desc={`Please enter the verification code given by our executive`}
              panelClass="max-w-[600px]"
            />
            <div>
              <div className="flex flex-col gap-3">
                {/* <label htmlFor="verify_code" className="label">
                  Enter Code <RequiredSymbol />
                </label> */}
                <div>
                  <Field
                    type="text"
                    className={`h-[40px] w-full rounded-lg border border-bodyText bg-none text-black shadow-none placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor autofill:bg-none autofill:shadow-none focus:border focus:border-primary focus:shadow-none focus:ring-0 ${
                      errors.verify_code && touched.verify_code
                        ? "!border-red-500"
                        : ""
                    }`}
                    autoComplete="off"
                    name="verify_code"
                    placeholder="Enter Account Verification Code"
                    validate={(value) => {
                      if (!value) {
                        return "Verification Code is required";
                      }
                    }}
                    onKeyUp={(e) => {
                      if (e.keyCode === 13) {
                        submitForm();
                      }
                    }}
                    autoFocus={true}
                    autocomplete="off"
                  />
                  <FieldErrorMessage name="verify_code" />
                </div>
              </div>
            </div>
            <div className="-mt-6">
              <AuthButton
                submitForm={submitForm}
                isSubmitting={isSubmitting}
                isValid={isValid}
                btnText={"Verify"}
                btnLoadingText={"Verifying..."}
              />
            </div>
          </Form>
        )}
      </Formik>
    </ModalPopUp>
  );
};

export default AccountVerificationModal;
